import axios from '@/axios'

const SEED_SOURCE_PREFIX = '/api/screen-config/seed-source'

export const getSeedSourceDetail = (id) => {
    if (!id && id !== 0) {
        return Promise.reject(new Error('seed source id is required'))
    }
    return axios.post(`${SEED_SOURCE_PREFIX}/detail/${id}`)
}

export const editSeedSource = (payload) => {
    if (!payload || typeof payload !== 'object') {
        return Promise.reject(new Error('payload is required'))
    }
    return axios.post(`${SEED_SOURCE_PREFIX}/edit`, payload)
}

// 介绍
export const getSeedSourceIntroduction = () => {
    return axios.post(`${SEED_SOURCE_PREFIX}/default-seed-source`)
}
